// AUTO-GENERATED by /app/scripts/optimize_media_images.py.
// Do not edit by hand — re-run the script to update.
// Maps optimized slug → { requestedWidth: actualWidth }.

export const MEDIA_IMAGES = {
  "behind-booth": {
    "480": 480,
    "800": 800,
    "1200": 1200
  },
  "bio": {
    "480": 480,
    "800": 800,
    "1200": 1067
  },
  "booth": {
    "480": 480,
    "800": 800,
    "1200": 1200
  },
  "hero": {
    "480": 480,
    "800": 800,
    "1200": 853
  },
  "performance-mic": {
    "480": 480,
    "800": 800,
    "1200": 1200
  },
  "studio": {
    "480": 480,
    "800": 800,
    "1200": 1200
  },
  "vision": {
    "480": 480,
    "800": 800,
    "1200": 853
  }
};
